import barcodeIcon from "../../../assets/images/missionItems/actors/barcode.png";
import colorIcon from "../../../assets/images/missionItems/actors/color_border.png";
import fireIcon from "../../../assets/images/missionItems/actors/fire.png";
import collectibleIcon from "../../../assets/images/missionItems/actors/collectible.png";
import collectiblePointIcon from "../../../assets/images/missionItems/actors/collectiblePoint.png";
import collectibleAppleIcon from "../../../assets/images/missionItems/actors/collectibleApple.png";
import collectibleBananaIcon from "../../../assets/images/missionItems/actors/collectibleBanana.png";
import collectibleCherryIcon from "../../../assets/images/missionItems/actors/collectibleCherry.png";
import collectibleWatermelonIcon from "../../../assets/images/missionItems/actors/collectibleWatermelon.png";
import collectibleSuperMarioCoinIcon from "../../../assets/images/missionItems/actors/collectibleSuperMarioCoin.png";
import collectibleSuperMarioHeartIcon from "../../../assets/images/missionItems/actors/collectibleSuperMarioHeart.png";
import collectibleSuperMarioMushroomIcon from "../../../assets/images/missionItems/actors/collectibleSuperMarioMushroom.png";
import collectibleSuperMarioPotionIcon from "../../../assets/images/missionItems/actors/collectibleSuperMarioPotion.png";
import collectibleWarcraftAxeIcon from "../../../assets/images/missionItems/actors/collectibleWarcraftAxe.png";
import collectibleWarcraftFunnelIcon from "../../../assets/images/missionItems/actors/collectibleWarcraftFunnel.png";
import collectibleWarcraftGoldIcon from "../../../assets/images/missionItems/actors/collectibleWarcraftGold.png";
import collectibleWarcraftHammerIcon from "../../../assets/images/missionItems/actors/collectibleWarcraftHammer.png";
import collectibleChaseCoinsIcon from "../../../assets/images/missionItems/actors/collectibleChaseCoins.png";
import collectibleChaseGoldIcon from "../../../assets/images/missionItems/actors/collectibleChaseGold.png";
import collectibleChaseBagOfGoldIcon from "../../../assets/images/missionItems/actors/collectibleChaseBagOfGold.png";
import collectibleChaseDiamondsIcon from "../../../assets/images/missionItems/actors/collectibleChaseDiamonds.png";
import humanIcon from "../../../assets/images/missionItems/actors/human_icon.png";
import humanChildIcon from "../../../assets/images/missionItems/actors/humanChild.png";
import humanManDogIcon from "../../../assets/images/missionItems/actors/humanManDog.png";
import humanCoupleIcon from "../../../assets/images/missionItems/actors/humanCouple.png";
import humanManIcon from "../../../assets/images/missionItems/actors/humanMan.png";
import humanWomanIcon from "../../../assets/images/missionItems/actors/humanWoman.png";
import humanScientistIcon from "../../../assets/images/missionItems/actors/humanScientist.png";
import qrIcon from "../../../assets/images/missionItems/actors/qr.png";
import poiIcon from "../../../assets/images/missionItems/actors/poi.png";
import poiEdge from "../../../assets/images/missionItems/actors/poi_edge.png";
import rfidIcon from "../../../assets/images/missionItems/actors/rfid.png";
import robotNormalRedIcon from "../../../assets/images/missionItems/general/robotNormalRed.png";
import robotNormalGreenIcon from "../../../assets/images/missionItems/general/robotNormalGreen.png";
import robotNormalBlueIcon from "../../../assets/images/missionItems/general/robotNormalBlue.png";
import robotNormalOrangeIcon from "../../../assets/images/missionItems/general/robotNormalOrange.png";
import robotNormalGreyIcon from "../../../assets/images/missionItems/general/robotNormalGrey.png";
import robotScientistRedIcon from "../../../assets/images/missionItems/general/robotScientistRed.png";
import robotScientistGreenIcon from "../../../assets/images/missionItems/general/robotScientistGreen.png";
import robotScientistBlueIcon from "../../../assets/images/missionItems/general/robotScientistBlue.png";
import robotScientistOrangeIcon from "../../../assets/images/missionItems/general/robotScientistOrange.png";
import robotScientistGreyIcon from "../../../assets/images/missionItems/general/robotScientistGrey.png";
import robotFormulaRedIcon from "../../../assets/images/missionItems/general/robotFormulaRed.png";
import robotFormulaGreenIcon from "../../../assets/images/missionItems/general/robotFormulaGreen.png";
import robotFormulaBlueIcon from "../../../assets/images/missionItems/general/robotFormulaBlue.png";
import robotFormulaOrangeIcon from "../../../assets/images/missionItems/general/robotFormulaOrange.png";
import robotFormulaGreyIcon from "../../../assets/images/missionItems/general/robotFormulaGrey.png";
import robotMiniRedIcon from "../../../assets/images/missionItems/general/robotMiniRed.png";
import robotMiniGreenIcon from "../../../assets/images/missionItems/general/robotMiniGreen.png";
import robotMiniBlueIcon from "../../../assets/images/missionItems/general/robotMiniBlue.png";
import robotMiniOrangeIcon from "../../../assets/images/missionItems/general/robotMiniOrange.png";
import robotMiniGreyIcon from "../../../assets/images/missionItems/general/robotMiniGrey.png";
import robotTractorRedIcon from "../../../assets/images/missionItems/general/robotTractorRed.png";
import robotTractorGreenIcon from "../../../assets/images/missionItems/general/robotTractorGreen.png";
import robotTractorBlueIcon from "../../../assets/images/missionItems/general/robotTractorBlue.png";
import robotTractorOrangeIcon from "../../../assets/images/missionItems/general/robotTractorOrange.png";
import robotTractorGreyIcon from "../../../assets/images/missionItems/general/robotTractorGrey.png";
import robotDroneRedIcon from "../../../assets/images/missionItems/general/robotDroneRed.png";
import robotDroneGreenIcon from "../../../assets/images/missionItems/general/robotDroneGreen.png";
import robotDroneBlueIcon from "../../../assets/images/missionItems/general/robotDroneBlue.png";
import robotDroneOrangeIcon from "../../../assets/images/missionItems/general/robotDroneOrange.png";
import robotDroneGreyIcon from "../../../assets/images/missionItems/general/robotDroneGrey.png";
import robotRoombaRedIcon from "../../../assets/images/missionItems/general/robotRoombaRed.png";
import robotRoombaGreenIcon from "../../../assets/images/missionItems/general/robotRoombaGreen.png";
import robotRoombaBlueIcon from "../../../assets/images/missionItems/general/robotRoombaBlue.png";
import robotRoombaOrangeIcon from "../../../assets/images/missionItems/general/robotRoombaOrange.png";
import robotRoombaGreyIcon from "../../../assets/images/missionItems/general/robotRoombaGrey.png";
import robotTaxiIcon from "../../../assets/images/missionItems/general/robotTaxi.png";
import robotPacmanIcon from "../../../assets/images/missionItems/general/robotPacman.png";
import robotPacmanClosedIcon from "../../../assets/images/missionItems/general/robotPacmanClosed.png";
import robotGhostRedIcon from "../../../assets/images/missionItems/general/robotGhostRed.png";
import robotGhostGreenIcon from "../../../assets/images/missionItems/general/robotGhostGreen.png";
import robotGhostBlueIcon from "../../../assets/images/missionItems/general/robotGhostBlue.png";
import robotGhostOrangeIcon from "../../../assets/images/missionItems/general/robotGhostOrange.png";
import robotGhostGreyIcon from "../../../assets/images/missionItems/general/robotGhostGrey.png";
import robotSuperMarioIcon from "../../../assets/images/missionItems/general/robotSuperMario.png";
import robotSuperMario2Icon from "../../../assets/images/missionItems/general/robotSuperMario2.png";
import robotSuperMarioDragonRedIcon from "../../../assets/images/missionItems/general/robotSuperMarioDragonRed.png";
import robotSuperMarioDragonGreenIcon from "../../../assets/images/missionItems/general/robotSuperMarioDragonGreen.png";
import robotSuperMarioDragonBlueIcon from "../../../assets/images/missionItems/general/robotSuperMarioDragonBlue.png";
import robotSuperMarioDragonOrangeIcon from "../../../assets/images/missionItems/general/robotSuperMarioDragonOrange.png";
import robotSuperMarioDragonGreyIcon from "../../../assets/images/missionItems/general/robotSuperMarioDragonGrey.png";
import robotWarcraftArcherIcon from "../../../assets/images/missionItems/general/robotWarcraftArcher.png";
import robotWarcraftKnightIcon from "../../../assets/images/missionItems/general/robotWarcraftKnight.png";
import robotWarcraftDragonRedIcon from "../../../assets/images/missionItems/general/robotWarcraftDragonRed.png";
import robotWarcraftDragonGreenIcon from "../../../assets/images/missionItems/general/robotWarcraftDragonGreen.png";
import robotWarcraftDragonBlueIcon from "../../../assets/images/missionItems/general/robotWarcraftDragonBlue.png";
import robotWarcraftDragonOrangeIcon from "../../../assets/images/missionItems/general/robotWarcraftDragonOrange.png";
import robotWarcraftDragonGreyIcon from "../../../assets/images/missionItems/general/robotWarcraftDragonGrey.png";
import robotChaseHeroIcon from "../../../assets/images/missionItems/general/robotChaseHero.png";
import robotChasePoliceIcon from "../../../assets/images/missionItems/general/robotChasePolice.png";
import robotAmbulanceIcon from "../../../assets/images/missionItems/general/robotAmbulance.png";
import robotPoliceIcon from "../../../assets/images/missionItems/general/robotPolice.png";
import robotRandomRedIcon from "../../../assets/images/missionItems/general/robotRandomRed.png";
import robotRandomGreenIcon from "../../../assets/images/missionItems/general/robotRandomGreen.png";
import robotRandomBlueIcon from "../../../assets/images/missionItems/general/robotRandomBlue.png";
import robotRandomOrangeIcon from "../../../assets/images/missionItems/general/robotRandomOrange.png";
import robotRandomGreyIcon from "../../../assets/images/missionItems/general/robotRandomGrey.png";
import soundIcon from "../../../assets/images/missionItems/actors/sound.png";
import textIcon from "../../../assets/images/missionItems/actors/text.png";
import wallIcon from "../../../assets/images/missionItems/actors/wall.png";
import wallEdge from "../../../assets/images/missionItems/actors/wall_edge.png";
import waterIcon from "../../../assets/images/missionItems/actors/water.png";

// Reusable Variable Definitions 

const VARS = {
	range: {
		type: "number",
		name: "Range",
		value: 20,
		min: 0,
		max: 1000,
		step: 1,
		precision: 1,
		format: "m",
		tooltipDisplay: false,
		metersDisplay: true,
	},
	message: {
		type: "text",
		name: "Message",
		value: "",
		placeholder: "Message",
		tooltipDisplay: true,
	},
	language: {
		type: "select",
		name: "Language",
		value: "EL",
		options: ["EL", "EN"],
		tooltipDisplay: false,
		metersDisplay: false,
	},
	linearSpeed: {
		type: "number",
		name: "Max Linear Speed",
		value: 0.2,
		min: 0,
		max: 10,
		step: 0.1,
		precision: 1,
		format: "m/s",
		tooltipDisplay: false,
		metersDisplay: false,
		needs: { automation: [true] },
	},
	angularSpeed: {
		type: "number",
		name: "Max Angular Speed",
		value: 0.2,
		min: 0,
		max: 10,
		step: 0.1,
		precision: 1,
		format: "rad/s",
		tooltipDisplay: false,
		metersDisplay: false,
		needs: { automation: [true] },
	},
	rgb: (name) => ({
		type: "number",
		name: name,
		value: 255,
		min: 0,
		max: 255,
		step: 1,
		precision: 0,
		tooltipDisplay: false,
		metersDisplay: false,
	}),
};

// Automation Logic Helpers

// Used by Barcode, Color, Fire, QR, RFID, Text
const getAutomationState = (stepVariables) => ({
	automation: {
		type: "boolean",
		name: "Predefined behavior (cannot be controlled)",
		value: false,
		tooltipDisplay: false,
		metersDisplay: false,
	},
	automationReverse: {
		type: "boolean",
		name: "Reverse State Transitions",
		value: false,
		tooltipDisplay: false,
		metersDisplay: false,
		needs: { automation: [true] },
	},
	automationLoop: {
		type: "boolean",
		name: "Loop State Transitions",
		value: false,
		tooltipDisplay: false,
		metersDisplay: false,
		needs: { automation: [true] },
	},
	stateAvailable: {
		type: "boolean",
		name: "State is Available",
		value: false,
		tooltipDisplay: false,
		metersDisplay: false,
		needs: { automation: [true] },
	},
	automationSteps: {
		type: "stateInput",
		name: "Automation Steps",
		value: [],
		variables: stepVariables,
		tooltipDisplay: false,
		metersDisplay: false,
		needs: { automation: [true] },
	},
});

// Used by Collectible, Human, Robot
const getMovementLogic = () => ({
	automation: {
		type: "boolean",
		name: "Make autonomous (cannot be controlled)",
		value: false,
		tooltipDisplay: false,
		metersDisplay: false,
	},
	automationPoints: {
		type: "pois",
		name: "Movement Points",
		placeholder: "Add Point",
		value: [],
		tooltipDisplay: false,
		metersDisplay: false,
		needs: { automation: [true] },
	},
	automationReverse: {
		type: "boolean",
		name: "Reverse Movement",
		value: false,
		tooltipDisplay: false,
		metersDisplay: false,
		needs: { automation: [true] },
	},
	automationLoop: {
		type: "boolean",
		name: "Movement Loop",
		value: false,
		tooltipDisplay: false,
		metersDisplay: false,
		needs: { automation: [true] },
	},
	stateAvailable: {
		type: "boolean",
		name: "State is Available",
		value: false,
		tooltipDisplay: false,
		metersDisplay: false,
		needs: { automation: [true] },
	},
	linearSpeed: VARS.linearSpeed,
	angularSpeed: VARS.angularSpeed,
});

// Icon & Skin Helpers 

// Helper for Collectible icons (Simple Image + Ratio)
const icon = (image, aspectRatio) => ({ image, aspectRatio });

// Helper for Robot Skins (Map colors to images)
// If 'red' is an array (like Pacman/Mario), it handles animation.
// If 'red' is the same as 'green' etc (like Taxi), it handles uniform skins.
const skinColors = (red, green, blue, orange, grey, aspectRatio, animationTime) => {
	const result = {
		image: {
			Red: red,
			Green: green,
			Blue: blue,
			Orange: orange,
			Grey: grey,
		},
		aspectRatio,
	};
	if (animationTime) result.animationTime = animationTime;
	return result;
};

// Helper for Robot skins that look the same in every color (e.g., Taxi, Police)
const skinUniform = (image, aspectRatio) => skinColors(image, image, image, image, image, aspectRatio);

// Sonar Helper 

const createSonar = (idSuffix, name, templateId) => ({
	type: "boolean",
	name: name,
	value: false,
	tooltipDisplay: true,
	metersDisplay: false,
	ids: [`sonar_${idSuffix}_`],
	templateId: templateId || `sonar_${idSuffix}`,
	parameters: ["distance"],
});


const general = {
	title: "General",
	items: {
		barcode: {
			icon: barcodeIcon,
			variables: {
				message: VARS.message,
				...getAutomationState(["message"]),
			},
			tooltip: {
				header: "Barcode",
				body: "A barcode component with a message",
			},
		},
		collectible: {
			icon: collectibleIcon,
			variables: {
				value: {
					type: "number",
					name: "Value",
					value: 1,
					min: 0,
					max: 1000,
					step: 1,
					precision: 1,
					tooltipDisplay: true,
					metersDisplay: false,
				},
				skin: {
					type: "select",
					name: "Skin",
					value: "Point",
					options: [
						"Apple", "Banana", "Cherry", "Watermelon", "Point",
						"SuperMario Coin", "SuperMario Heart", "SuperMario Mushroom", "SuperMario Potion",
						"Warcraft Axe", "Warcraft Funnel", "Warcraft Gold", "Warcraft Hammer",
						"Chase Coins", "Chase Gold", "Chase Bag of Gold", "Chase Diamonds",
					],
					tooltipDisplay: false,
					metersDisplay: false,
				},
				...getMovementLogic(),
			},
			tooltip: {
				header: "Collectible Item",
				body: "A collectible item that can be picked up and earn you points",
			},
			icons: {
				Point: icon(collectiblePointIcon, 0.991),
				Apple: icon(collectibleAppleIcon, 0.79),
				Banana: icon(collectibleBananaIcon, 1.439),
				Cherry: icon(collectibleCherryIcon, 0.862),
				Watermelon: icon(collectibleWatermelonIcon, 1.621),
				"SuperMario Coin": icon(collectibleSuperMarioCoinIcon, 1),
				"SuperMario Heart": icon(collectibleSuperMarioHeartIcon, 1.171),
				"SuperMario Mushroom": icon(collectibleSuperMarioMushroomIcon, 0.963),
				"SuperMario Potion": icon(collectibleSuperMarioPotionIcon, 0.726),
				"Warcraft Axe": icon(collectibleWarcraftAxeIcon, 1.01),
				"Warcraft Funnel": icon(collectibleWarcraftFunnelIcon, 1),
				"Warcraft Gold": icon(collectibleWarcraftGoldIcon, 1.194),
				"Warcraft Hammer": icon(collectibleWarcraftHammerIcon, 1),
				"Chase Coins": icon(collectibleChaseCoinsIcon, 1),
				"Chase Gold": icon(collectibleChaseGoldIcon, 1),
				"Chase Bag of Gold": icon(collectibleChaseBagOfGoldIcon, 1.056),
				"Chase Diamonds": icon(collectibleChaseDiamondsIcon, 1.063),
			},
		},
		color: {
			icon: colorIcon,
			variables: {
				r: VARS.rgb("Red"),
				g: VARS.rgb("Green"),
				b: VARS.rgb("Blue"),
				...getAutomationState(["r", "g", "b"]),
			},
			tooltip: {
				header: "Color",
				body: "A simulated area with a specific dominant color",
			},
		},
		fire: {
			icon: fireIcon,
			variables: {
				range: VARS.range,
				temperature: {
					type: "number",
					name: "Temperature",
					value: 150,
					min: 40,
					max: 1000,
					step: 1,
					precision: 1,
					format: "°C",
					tooltipDisplay: false,
					metersDisplay: false,
				},
				...getAutomationState(["range", "temperature"]),
			},
			tooltip: {
				header: "Fire",
				body: "A source of fire, denoting large temperatures",
			},
		},
		human: {
			icon: humanIcon,
			variables: {
				skin: {
					type: "select",
					name: "Skin",
					value: "Child",
					options: ["Child", "Man with Dog", "Couple", "Man", "Woman", "Scientist"],
					tooltipDisplay: false,
					metersDisplay: false,
				},
				move: {
					type: "boolean",
					name: "Move",
					value: false,
					tooltipDisplay: false,
					metersDisplay: false,
				},
				sound: {
					type: "boolean",
					name: "Sound",
					value: false,
					tooltipDisplay: false,
					metersDisplay: false,
				},
				language: VARS.language,
				range: VARS.range,
				speech: {
					type: "text",
					name: "Speech",
					value: "",
					placeholder: "Speech",
					tooltipDisplay: false,
					metersDisplay: false,
				},
				emotion: {
					type: "select",
					name: "Emotion",
					value: "Neutral",
					options: ["Happy", "Sad", "Crying", "Neutral", "Delighted", "Angry", "Disgusted", "Afraid"],
					tooltipDisplay: false,
					metersDisplay: false,
				},
				gender: {
					type: "select",
					name: "Gender",
					value: "None",
					options: ["None", "Male", "Female"],
					tooltipDisplay: false,
					metersDisplay: false,
				},
				age: {
					type: "number",
					name: "Age",
					value: 20,
					min: 0,
					max: 100,
					step: 1,
					precision: 0,
					format: "years",
					tooltipDisplay: false,
					metersDisplay: false,
				},
				// Note: Human used "Automation" as name instead of "Make autonomous...". Overriding the name.
				...(() => {
					const logic = getMovementLogic();
					logic.automation.name = "Automation";
					return logic;
				})(),
				automationSteps: {
					type: "stateInput",
					name: "Automation Steps",
					value: [],
					variables: ["language", "speech", "emotion"],
					tooltipDisplay: false,
					metersDisplay: false,
					needs: { automation: [true] },
				},
			},
			tooltip: {
				header: "Human",
				body: "A human that can also speak and walk",
			},
			icons: {
				Child: icon(humanChildIcon, 1),
				"Man with Dog": icon(humanManDogIcon, 1),
				Couple: icon(humanCoupleIcon, 1),
				Man: icon(humanManIcon, 1),
				Woman: icon(humanWomanIcon, 1),
				Scientist: icon(humanScientistIcon, 1),
			},
		},
		qr: {
			icon: qrIcon,
			variables: {
				message: VARS.message,
				...getAutomationState(["message"]),
			},
			tooltip: {
				header: "QR",
				body: "A QR component with a message",
			},
		},
		poi: {
			icon: poiIcon,
			variables: {},
			icons: {
				default: poiEdge,
			},
			tooltip: {
				header: "POI",
				body: "A point of interest to which items and devices can be moved",
			},
		},
		rfid: {
			icon: rfidIcon,
			variables: {
				message: VARS.message,
				...getAutomationState(["message"]),
			},
			tooltip: {
				header: "RFID Tag",
				body: "An RFID tag with a message",
			},
		},
		robot: {
			icon: robotNormalRedIcon,
			variables: {
				theta: {
					type: "number",
					name: "Theta",
					value: 0,
					min: -180,
					max: 180,
					step: 10,
					precision: 1,
					format: "°",
					tooltipDisplay: false,
					metersDisplay: false,
				},
				skin: {
					type: "select",
					name: "Skin",
					value: "Normal",
					options: [
						"Normal", "Pacman", "Ghost", "SuperMario", "SuperMario Dragon",
						"Warcraft Knight", "Warcraft Archer", "Warcraft Dragon",
						"Chase Hero", "Chase Police", "Scientist", "Formula",
						"Mini", "Tractor", "Drone", "Roomba", "Taxi", "Ambulance", "Police", "Random",
					],
					tooltipDisplay: false,
					metersDisplay: false,
				},
				skinColor: {
					type: "select",
					name: "Skin Color",
					value: "Red",
					options: ["Red", "Green", "Blue", "Orange", "Grey"],
					tooltipDisplay: false,
					metersDisplay: false,
					needs: { skin: ["Normal", "Ghost", "SuperMario Dragon", "Warcraft Dragon", "Scientist", "Formula", "Mini", "Tractor", "Drone", "Roomba", "Random"] },
				},
				...getMovementLogic(),
				microphone: {
					type: "boolean",
					name: "Microphone",
					value: false,
					tooltipDisplay: true,
					metersDisplay: false,
					ids: ["microphone_front_"],
					needs: { automation: [false] },
					templateId: "microphone",
					parameters: [["duration"]],
				},
				camera: {
					type: "boolean",
					name: "Camera",
					value: false,
					tooltipDisplay: true,
					metersDisplay: false,
					ids: ["tektrain_camera_"],
					needs: { automation: [false] },
					templateId: "camera",
					parameters: [["-"]],
				},
				cameraOnPanTilt: {
					type: "boolean",
					name: "Camera on Pan-Tilt",
					value: false,
					tooltipDisplay: false,
					metersDisplay: false,
					ids: ["pan_tilt_"],
					parameters: [["pan", "tilt"]],
					needs: { camera: [true], automation: [false] },
				},
				cameraRealImages: {
					type: "boolean",
					name: "Generate Real Images",
					value: false,
					tooltipDisplay: false,
					metersDisplay: false,
					ids: ["tektrain_camera_real_images_"],
					parameters: [["-"]],
					needs: { camera: [true], automation: [false] },
				},
				imu: {
					type: "boolean",
					name: "IMU",
					value: false,
					tooltipDisplay: true,
					metersDisplay: false,
					ids: ["imu_"],
					needs: { automation: [false] },
					templateId: "imu",
					parameters: [["acceleration.x", "acceleration.y", "acceleration.z", "gyroscope.yaw", "gyroscope.pitch", "gyroscope.roll", "magnetometer.yaw", "magnetometer.pitch", "magnetometer.roll"]],
				},
				env: {
					type: "boolean",
					name: "Environmental",
					value: false,
					tooltipDisplay: true,
					metersDisplay: false,
					ids: ["env_"],
					needs: { automation: [false] },
					templateId: "env",
					parameters: [["data.temperature", "data.pressure", "data.humidity", "data.gas"]],
				},
				speaker: {
					type: "boolean",
					name: "Speaker",
					value: false,
					tooltipDisplay: true,
					metersDisplay: false,
					ids: ["speaker_front_"],
					needs: { automation: [false] },
					templateId: "speaker",
					parameters: [["text", "volume", "language"]],
				},
				leds: {
					type: "boolean",
					name: "LEDs",
					value: false,
					tooltipDisplay: true,
					metersDisplay: false,
					ids: ["leds_front_"],
					needs: { automation: [false] },
					templateId: "leds",
					parameters: [["r", "g", "b", "intensity"]],
				},
				panTilt: {
					type: "boolean",
					name: "Pan-Tilt",
					value: false,
					hide: true,
					tooltipDisplay: false,
					metersDisplay: false,
					ids: ["pan_tilt_"],
					needs: { automation: [false] },
					templateId: "pan_tilt",
					parameters: [["pan", "tilt"]],
				},
				rfid_reader: {
					type: "boolean",
					name: "RFID Reader",
					value: false,
					tooltipDisplay: false,
					metersDisplay: false,
					ids: ["rfid_reader_"],
					needs: { automation: [false] },
					templateId: "rfid_reader",
					parameters: [["data.tags.<tag_name>"]],
				},
				rfidOnPanTilt: {
					type: "boolean",
					name: "RFID on Pan-Tilt",
					value: false,
					tooltipDisplay: false,
					metersDisplay: false,
					ids: ["pan_tilt_"],
					parameters: [["pan", "tilt"]],
					needs: { rfid_reader: [true], automation: [false] },
				},
				sonar: {
					type: "extra",
					name: "Sonar",
					needs: { automation: [false] },
					tooltipDisplay: true,
					metersDisplay: false,
					extra: {
						sonar_bl: createSonar("bl", "Back Left"),
						sonar_br: createSonar("br", "Back Right"),
						sonar_fl: createSonar("fl", "Front Left"),
						sonar_f: createSonar("f", "Front"),
						sonar_fr: createSonar("fr", "Front Right"),
						sonar_l: createSonar("l", "Left"),
						sonar_r: createSonar("r", "Right"),
						sonar_pan_tilt: createSonar("pan_tilt", "On Pan-Tilt", "sonar_c"),
					},
				},
			},
			tooltip: {
				header: "Robot",
				body: "A robot is a moving agent that is able to interact with the environment via actuators and measure properties of the environment via sensors",
			},
			icons: {
				Normal: skinColors(robotNormalRedIcon, robotNormalGreenIcon, robotNormalBlueIcon, robotNormalOrangeIcon, robotNormalGreyIcon, 1.158),
				Scientist: skinColors(robotScientistRedIcon, robotScientistGreenIcon, robotScientistBlueIcon, robotScientistOrangeIcon, robotScientistGreyIcon, 1.771),
				Formula: skinColors(robotFormulaRedIcon, robotFormulaGreenIcon, robotFormulaBlueIcon, robotFormulaOrangeIcon, robotFormulaGreyIcon, 1.983),
				Mini: skinColors(robotMiniRedIcon, robotMiniGreenIcon, robotMiniBlueIcon, robotMiniOrangeIcon, robotMiniGreyIcon, 1.746),
				Pacman: skinColors(
					[robotPacmanIcon, robotPacmanClosedIcon],
					[robotPacmanIcon, robotPacmanClosedIcon],
					[robotPacmanIcon, robotPacmanClosedIcon],
					[robotPacmanIcon, robotPacmanClosedIcon],
					[robotPacmanIcon, robotPacmanClosedIcon],
					0.94, 200
				),
				Ghost: skinColors(robotGhostRedIcon, robotGhostGreenIcon, robotGhostBlueIcon, robotGhostOrangeIcon, robotGhostGreyIcon, 1.03),
				SuperMario: skinColors(
					[robotSuperMarioIcon, robotSuperMario2Icon],
					[robotSuperMarioIcon, robotSuperMario2Icon],
					[robotSuperMarioIcon, robotSuperMario2Icon],
					[robotSuperMarioIcon, robotSuperMario2Icon],
					[robotSuperMarioIcon, robotSuperMario2Icon],
					0.681
				),
				"SuperMario Dragon": skinColors(robotSuperMarioDragonRedIcon, robotSuperMarioDragonGreenIcon, robotSuperMarioDragonBlueIcon, robotSuperMarioDragonOrangeIcon, robotSuperMarioDragonGreyIcon, 1.038),
				"Warcraft Knight": skinUniform(robotWarcraftKnightIcon, 1),
				"Warcraft Archer": skinUniform(robotWarcraftArcherIcon, 0.932),
				"Warcraft Dragon": skinColors(robotWarcraftDragonRedIcon, robotWarcraftDragonGreenIcon, robotWarcraftDragonBlueIcon, robotWarcraftDragonOrangeIcon, robotWarcraftDragonGreyIcon, 1.121),
				"Chase Hero": skinUniform(robotChaseHeroIcon, 2.121),
				"Chase Police": skinUniform(robotChasePoliceIcon, 2.159),
				Tractor: skinColors(robotTractorRedIcon, robotTractorGreenIcon, robotTractorBlueIcon, robotTractorOrangeIcon, robotTractorGreyIcon, 1.65),
				Drone: skinColors(robotDroneRedIcon, robotDroneGreenIcon, robotDroneBlueIcon, robotDroneOrangeIcon, robotDroneGreyIcon, 1),
				Roomba: skinColors(robotRoombaRedIcon, robotRoombaGreenIcon, robotRoombaBlueIcon, robotRoombaOrangeIcon, robotRoombaGreyIcon, 1.004),
				Taxi: skinUniform(robotTaxiIcon, 1.983),
				Ambulance: skinUniform(robotAmbulanceIcon, 1.983),
				Police: skinUniform(robotPoliceIcon, 1.983),
				Random: skinColors(robotRandomRedIcon, robotRandomGreenIcon, robotRandomBlueIcon, robotRandomOrangeIcon, robotRandomGreyIcon, 1.983),
			},
		},
		sound: {
			icon: soundIcon,
			variables: {
				language: VARS.language,
				range: VARS.range,
				speech: {
					type: "text",
					name: "Speech",
					value: "",
					placeholder: "Speech",
					tooltipDisplay: false,
					metersDisplay: false,
				},
				emotion: {
					type: "select",
					name: "Emotion",
					value: "Neutral",
					options: ["Happy", "Sad", "Crying", "Neutral", "Delighted", "Angry", "Disgusted", "Afraid"],
					tooltipDisplay: false,
					metersDisplay: false,
				},
				...getAutomationState(["language", "speech", "emotion"]),
			},
			tooltip: {
				header: "Sound",
				body: "A sound source",
			},
		},
		text: {
			icon: textIcon,
			variables: {
				text: {
					type: "text",
					name: "Text",
					value: "",
					placeholder: "Text",
					tooltipDisplay: true,
				},
				...getAutomationState(["text"]),
			},
			tooltip: {
				header: "Text",
				body: "A text that denotes a message and can be detected via OCR algorithms",
			},
		},
		wall: {
			icon: wallIcon,
			itemType: "double",
			variables: {},
			icons: {
				1: wallEdge,
				2: wallEdge,
			},
			tooltip: {
				header: "Wall",
				body: "A wall is an obstacle you can place anywhere in the map in order to not allow the robot to pass through. Walls are detectable from the robot’s distance sensors",
			},
		},
		water: {
			icon: waterIcon,
			variables: {
				range: VARS.range,
			},
			tooltip: {
				header: "Water",
				body: "A source of water, denoting high humidity",
			},
		},
	},
};

export default general;